var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCopyclip(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.4737 0H4.21053C2.99474 0 2 0.981818 2 2.18182V17.4545H4.21053V2.18182H17.4737V0ZM20.7895 4.36364H8.63158C7.41579 4.36364 6.42105 5.34545 6.42105 6.54545V21.8182C6.42105 23.0182 7.41579 24 8.63158 24H20.7895C22.0053 24 23 23.0182 23 21.8182V6.54545C23 5.34545 22.0053 4.36364 20.7895 4.36364ZM20.7895 21.8182H8.63158V6.54545H20.7895V21.8182Z",
    fill: "#329DFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopyclip);
export default __webpack_public_path__ + "static/media/copyclip.d75b4c202688747d38a232de399ec21e.svg";
export { ForwardRef as ReactComponent };